import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 통합관리코스리스트
const get_admincourselist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 0,
    courselistcnt: "0",
    courselist: [],
  };
  const options = {
    method: "GET",
    url: "/course/courselist",
    params: {
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admincourselist", err);
    result(false, err);
  }
};

// 통합관리코스보기
const get_admincourseview = async (courseno, result) => {
  let finalData = {
    code: 200,
    message: "",
    coursebasicinfo: [
      {
        area: "",
        coursename: "",
        course_image_url: "",
        field: "",
        green: "",
        hole: "",
        par: "",
        distance: "",
        contents: "",
      },
    ],
    subcoursecnt: "",
    subcourse: [
      {
        subcourseseq: "",
        subcourseno: "",
        subcoursename: "",
        subcoursehole: [],
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/course/courseview/" + courseno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_admincourseview", err);
    result(false, err);
  }
};

// 통합관리코스홀보기
const get_admincourseholeview = async (
  courseno,
  holeno,
  coursubtype,
  result
) => {
  let finalData = {
    code: "",
    message: "",
    courseholeview: [
      {
        subcoursename: "",
        par: "",
        minimap_name: "",
        grnmap1_name: "",
        grnmap2_name: "",
        movie_name: "",
        minimap_url: "",
        grnmap1_url: "",
        grnmap2_url: "",
        movie_url: "",

        contents: "",
      },
    ],
  };

  const options = {
    method: "GET",
    url:
      "/course/courseholeview/" + courseno + "/" + coursubtype + "/" + holeno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admincourseholeview", err);
    result(false, err);
  }
};

// 통합관리코스보기
const post_subcoursecntcheck = async (courseno, subcourselistcnt, result) => {
  let finalData = {
    code: 200,
    message: "",
  };
  const options = {
    method: "POST",
    url: "/course/ajax_subcourse_cnt_check/" + courseno,
    data: qs.stringify({
      subcourselistcnt: subcourselistcnt,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admincourseview", err);
    result(false, err);
  }
};

// 통합관리코스등록
const set_admincoursewrite = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/course/coursewrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        // finalData = _.merge(finalData, response.data)
        // result(true, finalData)
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_admincoursewrite", err);
    result(false, err);
  }
};

// 통합관리코스수정
const set_admincourseedit = async (courseno, formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/course/coursewrite/" + courseno,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
        // finalData = _.merge(finalData, response.data)
        // result(true, finalData)
      }
    });
  } catch (err) {
    console.error("set_admincourseedit", err);
    result(false, err);
  }
};

// 통합관리코스홀등록
const set_admincourseholewrite = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/course/courseholewrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("set_admincourseholewrite", err);
    result(false, err);
  }
};

// 통합관리코스수정
const set_admincourseholeedit = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/course/courseholewrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        // console.error(response.data.code, response.data.message)
        // result(false, response.data.message)
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      }
    });
  } catch (err) {
    console.error("set_admincourseholeedit", err);
    result(false, err);
  }
};

export default {
  get_admincourselist,
  get_admincourseview,
  get_admincourseholeview,
  set_admincoursewrite,
  set_admincourseedit,
  set_admincourseholewrite,
  set_admincourseholeedit,
  post_subcoursecntcheck,
};
